import * as React from 'react'
import { Button, Col, Container, Image, Row } from 'react-bootstrap'
import {
  customBtn,
  description,
  heading,
  iwtContainer,
  text,
} from './iwt.module.scss'

const IWT = ({ content, shop, reverse }) => {
  const btnText = shop ? 'Shop Now' : 'Learn More'

  return content.map((iwt, index) => {
    return (
      <Container className={iwtContainer} key={`${iwt.title}`}>
        <Row className={reverse ? 'flex-lg-row-reverse' : 'default'}>
          <Col className='image px-0' lg={6}>
            <Image
              src={
                iwt.staticImage
                  ? iwt.staticImage
                  : iwt.image.gatsbyImageData.images.fallback.src
              }
              alt={iwt.title}
            />
          </Col>
          <Col className={text} lg={6}>
            {iwt.titleHat ? <h5 className='my-4'>{iwt.titleHat}</h5> : ''}
            <h2 className={heading}>{iwt.title}</h2>
            <p className={description}>
              {iwt.text ? iwt.text : iwt.description.description}
            </p>
            <Button
              href={iwt.url}
              variant='link'
              className='pb-lg-0 mt-4 px-0 pb-4'
            >
              {iwt.title}
            </Button>
          </Col>
        </Row>
      </Container>
    )
  })
}

export default IWT
